export default "__VITE_ASSET__5069b2b0__"